export default "__VITE_ASSET__VpQdi87N__"